<template>
  <modal :show="show" @change="$emit('change', $event)" width="450">
    <template v-slot:header>
      <span>{{ header }}</span>
    </template>
    <template v-slot:main>
      <div class="modal-info mx-7">
        <div class="d-block mt-3 fs-18 text-center">
          <span v-if="!domHoz" class="blinking-text">
            {{ text }}{{ domHoz }}</span
          >
          <div v-else>
            <span class="green--text"
              ><strong
                >Услуга "Электронный ЕПД" <br />подключена успешно!</strong
              ></span
            >
            <div class="mt-5 fs-16"
              >Платежный документ (квитанция) на оплату <br />ЖКУ по лицевому
              счету №{{ domHoz }} <br />будет ежемесячно направляться <br />на
              электронную почту <span class="blue-line">{{ email }}</span></div
            ><br/>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";

export default {
  name: "ModalGuestApplication",
  directives: {
    mask,
  },
  components: {
    Modal,
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Ожидаем ответа сервера...",
    },
    header: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    domHoz: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    message: "",
  }),
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.modal-info {
  min-height: 50px;

  &__message {
    margin: auto;
  }
}

@keyframes blink {
  0% {
    opacity: 1;
  } /* Полностью видим */
  50% {
    opacity: 0.2;
  } /* Исчезает */
  100% {
    opacity: 1;
  }
}

.blinking-text {
  animation: blink 2s infinite;
}

.blue-line{
  color:blue;
  text-decoration: underline;
}
</style>
